export default __webpack_public_path__ + "static/media/learnMoreHover.98449ca7.png";